import axios from '../utils/axios';

export default function getUnapprovedCompanyRecruiters (adminId, params) {
    return axios.get(`/admin/${adminId}/get-unverified-company-recruiters`, { params });
}